var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-flow"},[(_vm.configResult && _vm.isInit)?_c('FlowEngine',{attrs:{"module":_vm.configResult.form_uuid || _vm.configResult.object_uuid,"obuuid":_vm.obuuid}}):_c('el-empty',{attrs:{"description":"流程配置错误"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }